<template>
  <div class="secondlayout">
    <!-- <div class="secondlayout-header">
      <router-link to="/" class="secondlayout-index">首页</router-link>
    </div> -->
    <div class="secondlayout-main clearfix">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "secondlayout",
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped rel="stylesheet/less">
.secondlayout {
  height: 100%;
  overflow: hidden;
  // background-color: #fff;
  background: linear-gradient(163deg, #51B3FA 0%, #287CF3 100%);
  &-index {
    width: 300px;
    height: 30px;
    opacity: 0;
    display: block;
    overflow: hidden;
  }
  &-header {
    width: 1200px;
    margin: 40px auto 0 auto;
    height: 31px;
    background: url("../../assets/images/slogan.png") no-repeat left top;
  }
  &-main {
    height: 100%;
    position: relative;
  }
}
</style>
